import { createFileRoute } from "@tanstack/react-router";
import { useScope } from "@/hooks/use-scope";
import { useImplementationProgress } from "@/lib/implementation-progress";
import {
  TrackPageHeader,
  ChecklistStrip,
  SectionGrid,
  type TrackSection,
} from "@/components/implementation/track-page";

export const Route = createFileRoute("/_authenticated/app/implementation/workspace/validation")({
  component: ValidationTrack,
});

function ValidationTrack() {
  const { tenantId } = useScope();
  const progress = useImplementationProgress(tenantId);
  const track = progress.tracks.validation;

  const sections: TrackSection[] = [
    {
      id: "integration_tests",
      name: "Integration tests",
      eyebrow: "Prove the plumbing",
      description:
        "Round-trip every connected system — orders in, shipments out, inventory reconciled, webhooks delivered.",
      status: "coming",
      actions: [{ label: "Not yet available", disabled: true, icon: "arrow" }],
    },
    {
      id: "test_orders",
      name: "Test orders",
      eyebrow: "Prove the flow",
      description:
        "Drop a handful of representative orders through the full pick-pack-ship path. Signed off, logged, retained.",
      status: "coming",
      actions: [{ label: "Not yet available", disabled: true, icon: "arrow" }],
    },
    {
      id: "test_labels",
      name: "Test labels",
      eyebrow: "Prove the labels",
      description:
        "Print a label from every carrier and service. Confirm formats, printers, and manifest behavior.",
      status: "coming",
      actions: [{ label: "Not yet available", disabled: true, icon: "arrow" }],
    },
    {
      id: "validation_log",
      name: "Validation log",
      eyebrow: "Evidence, not memory",
      description:
        "Every test run — who, when, result, artifact. This is what go-live is built on, and what audits ask for.",
      status: "coming",
      actions: [{ label: "Not yet available", disabled: true, icon: "arrow" }],
    },
    {
      id: "go_live",
      name: "Go-Live readiness",
      eyebrow: "The final check",
      description:
        "One console that composes every promise across the four tracks. Green means you're cleared to activate.",
      status: "future",
      actions: [{ label: "Post-launch surface", disabled: true, icon: "arrow" }],
    },
  ];

  return (
    <div>
      <TrackPageHeader
        track={track}
        eyebrow="Track 04 · Validation"
        description="Proof — not configuration. Validation exists to demonstrate that the first three tracks actually work together, with evidence you can hand to a customer, an auditor, or your future self."
      />
      <ChecklistStrip track={track} />
      <SectionGrid sections={sections} />
    </div>
  );
}